<twc-popup [closable]="false" cwChromePickerSelector [colorBackground]="hexadecimalValue"
    caption="{{hexadecimalValue}}">
    <twc-popup-content>
        <sketch-picker class="width-100" [(color)]="colorData" [control]="sketchControl"></sketch-picker>
    </twc-popup-content>
    <twc-popup-footer>
        <button class="twc-button twc-button-link" (click)="cancel()">{{'GENERAL.CANCEL' |
            translate}}</button>
        <button class="twc-button twc-ml-2 twc-button-primary" (click)="sendRGBColor()">{{'GENERAL.SELECT' |
            translate}}</button>
    </twc-popup-footer>
</twc-popup>